import * as Colors from "../Colors";
import { assign } from "lodash";

// *
// * Typography
// *
const letterSpacing = "normal";
const fontSize = 12;
// *
// * Layout
// *
const padding = 8;
const baseProps = {
  width: 350,
  height: 350,
  padding: 50,
};
// *
// * Labels
// *
const baseLabelStyles = {
  fontFamily: "Poppins",
  fontSize,
  letterSpacing,
  padding: 10,
  fill: Colors.PURPLE,
  stroke: "transparent",
};

const centeredLabelStyles = assign({ textAnchor: "middle" }, baseLabelStyles);
// *
// * Strokes
// *
const strokeLinecap = "round";
const strokeLinejoin = "round";

export default {
  axis: assign(
    {
      style: {
        axis: {
          fill: "transparent",
          stroke: Colors.PURPLE,
          strokeWidth: 1,
          strokeLinecap,
          strokeLinejoin,
        },
        axisLabel: assign({}, centeredLabelStyles, {
          padding: 25,
        }),
        grid: {
          fill: "none",
          stroke: "none",
          pointerEvents: "painted",
        },
        ticks: {
          fill: "transparent",
          size: 1,
          stroke: "transparent",
        },
        tickLabels: baseLabelStyles,
      },
    },
    baseProps
  ),
  boxplot: assign(
    {
      style: {
        max: { padding, stroke: Colors.PURPLE, strokeWidth: 1 },
        maxLabels: assign({}, baseLabelStyles, { padding: 3 }),
        median: { padding, stroke: Colors.PURPLE, strokeWidth: 1.5 },
        // medianLabels: assign({}, baseLabelStyles, { padding: 1 }),
        min: { padding, stroke: Colors.PURPLE, strokeWidth: 1 },
        minLabels: assign({}, baseLabelStyles, { padding: 3 }),
        medianLabels: assign({}, baseLabelStyles, { padding: 3 }),
        q1: { padding, fill: Colors.ORANGE },
        // q1Labels: assign({}, baseLabelStyles, { padding: 3 }),
        q3: { padding, fill: Colors.ORANGE },
        // q3Labels: assign({}, baseLabelStyles, { padding: 3 })
      },
      boxWidth: 20,
    },
    baseProps
  ),
};
